import { SocialConnectionsResponse } from '../api';

export const haveSocialsConnect = (currentSocials: SocialConnectionsResponse | null): boolean => {
  if (!currentSocials) {
    return false;
  }

  const connectedSocials = currentSocials.filter((social) => social.connected);
  return connectedSocials.length !== 0;
};
